export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10180.b72412a0.jpg";